<template>
<v-card flat color="transparent" :style="`color:white; margin-left:0px!important; margin-right:0px!important;`" :img="require(`../../assets/Background_grey.png`)">
    <v-img class="cardback" contain>
        <v-card-title class="headline"  :style="`color:white; justify-content:center; margin-top;border-width:thick; border-style:ridged; border-color:black; word-break:break-word; position: relative;`">
            <v-icon 
            class="edit-icon" 
            @click="$emit('edit-spell', parsedItem)" 
            style="position: absolute; right: 24px; cursor: pointer; color: white;"
            >
            settings
            </v-icon>
            {{ parsedItem.name }}
        </v-card-title>
        <v-row style="align-items: center;margin-bottom: 8px;margin-top: 8px; color:white"><v-divider></v-divider> Description <v-divider></v-divider></v-row>
        <v-card-text v-if="!item.fromAP" style="color: white; text-align: left;">
            <div v-if="parsedItem.description_formatted" v-html="parsedItem.description_formatted" class="spell-description"></div>
            <div v-else-if="parsedItem.full_text" v-html="parsedItem.full_text" class="spell-description"></div>
            <div v-else-if="parsedItem.description" class="spell-description">
                {{ parsedItem.description }}
            </div>
            <div v-else class="spell-description">
                <p>No description available for this spell.</p>
            </div>
        </v-card-text>
        <v-card-text v-else style="color: white; text-align: left;">
          <v-row v-if="item.longDesc">
              <v-col sm="6">
                  Level {{ item.level }}
                  <br />Type: <span v-for="type in item.type" v-bind:key="type"> {{type}}, </span>
                  <br />Range: {{ item.range }} <br />
                  <span v-if="item.area && item.area.length > 0">Area: {{ item.area }} <br /></span>
                  <div v-if="item.targets && item.targets.length > 0">Targets: {{ item.targets }} <br /></div>
                  Duration: {{ item.duration }} <br />
                  Saving Throw: {{ item.savingThrow }} <br />              
              </v-col>
              <v-col>
                  Casting Time: {{ item.castingTime }}
                  <br />School: {{ item.school }}<span v-if="item.tags && item.tags.length > 0"> <span v-for="tag in item.tags" v-bind:key="tag"> [{{tag}}], </span></span><br />
                  <span v-if="item.effect && item.effect.length > 0">Effect: {{ item.effect }} <br /></span>
                  <span v-if="item.components && item.components.length > 0">Components: {{ item.components }} <br /></span>
                  <span v-if="item.spellResistance && item.spellResistance.length > 0">Spell Resistance: {{ item.spellResistance }} <br /></span>
                  <span v-if="item.temporary">Temporary: {{ item.temporary }} <br /></span>
              </v-col>
            </v-row>
            <v-row v-else>
                <v-col sm="6">
                    Level: {{ item.level }}
                    <br />Discipline: {{ item.discipline }}
                    <br />Range: {{ item.range }}
                    <span v-if="item.area && item.area.length > 0"><br />Area: {{ item.area }}<br /></span>
                    <div v-if="item.target && item.target.length > 0">Targets: {{ item.target }} <br /></div>
                    Duration: {{ item.duration }} <br />
                     <br /> 
                </v-col>
                <v-col>
                    Manifesting Time: {{ item.manifestingTime }}<br />
                    <span v-if="item.display && item.display.length > 0">Display: {{ item.display }} <br /></span>
                    <span v-if="item.powerResistance && item.powerResistance.length > 0">Power Resistance: {{ item.powerResistance }} <br /></span>
                    <span v-if="item.savingThrow && item.savingThrow.length > 0">Saving Throw: {{ item.savingThrow }} <br /></span>
                    Power Points: {{ item.powerPoints }}
                </v-col>
            </v-row>
            <v-row style="align-items: center;margin-bottom: 8px;margin-top: 8px;"><v-divider></v-divider> Description <v-divider></v-divider></v-row>
          <span style="white-space: pre-wrap"
          >{{ item.longDesc || item.description }} <br />
          </span>
        </v-card-text>
    </v-img>
</v-card>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  methods: {
    
  },
  computed: {
    parsedItem(){
      return this.item;
    },
  }
}
</script>

<style scoped>
.spell-description {
  line-height: 1.6;
  font-size: 14px;
  color: white;
}

/* Paragraph tags */
.spell-description p {
  margin-bottom: 12px;
  text-align: justify;
}

.spell-description p:last-child {
  margin-bottom: 0;
}

/* Heading tags */
.spell-description h1, .spell-description h2, .spell-description h3, 
.spell-description h4, .spell-description h5, .spell-description h6 {
  margin-top: 16px;
  margin-bottom: 8px;
  font-weight: bold;
  color: white;
}

/* List tags */
.spell-description ul, .spell-description ol {
  margin-bottom: 12px;
  padding-left: 20px;
}

.spell-description li {
  margin-bottom: 4px;
}

/* Emphasis tags */
.spell-description strong, .spell-description b {
  font-weight: bold;
  color: #FFD700;
}

.spell-description em, .spell-description i {
  font-style: italic;
}

/* Link tags */
.spell-description a {
  color: #87CEEB;
  text-decoration: underline;
}

.spell-description a:hover {
  color: #FFD700;
}

/* Blockquote tags */
.spell-description blockquote {
  margin: 12px 0;
  padding-left: 12px;
  border-left: 3px solid #654321;
  font-style: italic;
}

/* Code tags */
.spell-description code {
  background-color: rgba(255, 255, 255, 0.1);
  padding: 2px 4px;
  border-radius: 3px;
  font-family: monospace;
}

/* Pre tags */
.spell-description pre {
  background-color: rgba(255, 255, 255, 0.1);
  padding: 8px;
  border-radius: 4px;
  overflow-x: auto;
  margin: 12px 0;
}

/* Table tags */
.spell-description table {
  border-collapse: collapse;
  margin: 12px 0;
  width: 100%;
}

.spell-description th, .spell-description td {
  border: 1px solid #654321;
  padding: 6px 8px;
  text-align: left;
}

.spell-description th {
  background-color: rgba(101, 67, 33, 0.3);
  font-weight: bold;
}

/* Div and span tags */
.spell-description div {
  margin-bottom: 8px;
}

.spell-description span {
  display: inline;
}

/* Style for spell details */
.text-subtitle-2 {
  font-weight: 600;
  margin-bottom: 4px;
}
</style>